import React from 'react';

import './SidebarTrigger.scss';

function SidebarTrigger({ sidebarTriggerClickHandler, isSidebarOpen }) {
  return (
    <div className={`mn_sidebarTriggerWrap ${isSidebarOpen ? 'mn_focusedSidebar' : ''}`}>
      <button
        className="mn_sidebarTrigger"
        aria-expanded={isSidebarOpen}
        aria-label="Toggle navigation"
        onClick={sidebarTriggerClickHandler}
      >
        <i className="mn_sidebarTriggerOpen mn_unitedIconHamburgerMenu" aria-hidden="true" />
        <i className="mn_sidebarTriggerClose mn_unitedIconClose" aria-hidden="true" />
      </button>
    </div>
  );
}

export default SidebarTrigger;
